import { IConsultantProfile } from "../types-ensure";

export const isBlocked = (profile: IConsultantProfile) => profile.blocked;
